module.exports = __webpack_public_path__ + "static/media/equmenia-vit-ik.265a4e3a.png";